export default "__VITE_ASSET__W4PAFF2T__"